import { Button, Modal } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

const getBackgroundColor = (index: number): string => (index % 2 === 0 ? "#F3F3F3" : "#FFFFFF");

export const ImportLogModal = ({ notification }: Props) => {
  const [open, setOpen] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <>
      <Modal width={800} open={open} footer={null} onCancel={() => setOpen(false)}>
        <h3 style={{ margin: 0 }}>{formatMessage({ id: "import.log.modal" })}</h3>
        <div>
          {notification?.data?.Count && <span>{`${formatMessage({ id: "notification.import.count" })}: ${notification.data.Count}`}</span>}
          {notification?.data?.FailedCount && (
            <span
              style={{ marginLeft: 10 }}
            >{`${formatMessage({ id: "notification.import.failedCount" })}: ${notification?.data?.FailedCount}`}</span>
          )}
        </div>
        <div
          style={{
            maxHeight: 350,
            overflowY: "auto",
          }}
        >
          {Object.entries(notification?.data || []).map(([key, value], index) =>
            ["Count", "FailedCount"].includes(key) ? null : (
              <div
                style={{
                  padding: 3,
                  backgroundColor: getBackgroundColor(index),
                }}
                key={key}
              >
                <strong>{key}:</strong> {value.toString()}
              </div>
            ),
          )}
        </div>
      </Modal>
      <Button
        type="primary"
        key="import.log.details"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
        onClick={() => {
          setOpen(true);
        }}
      >
        {formatMessage({ id: "notification.import.log.show" })}
      </Button>
    </>
  );
};
